import {
  ClientEntity,
  clientAddressEquals
} from "@common-core/coat-operational-hierarchy-appsync-model";
import {PrimaryClientAddress} from "./PrimaryClientAddress";
import {primaryAddressesFromClientEntity} from "./primaryAddressesFromClientEntity";

/**
 * The {@link uniquePrimaryAddresses} is a reducer function that removes any
 * duplicate {@link ClientAddress} from the collected {@link PrimaryClientAddress}
 * list, ensuring only unique addresses are retained.
 *
 * @param collected
 * @param candidate
 */
const uniquePrimaryAddresses = (
  collected: PrimaryClientAddress[],
  candidate: PrimaryClientAddress
): PrimaryClientAddress[] => {
  const duplicate = collected.some(existing =>
    clientAddressEquals(existing.address, candidate.address)
  );
  if (!duplicate) {
    collected.push(candidate);
  }
  return collected;
};

/**
 * The {@link collectPrimaryAddresses} collects a {@link PrimaryClientAddress} list
 * from a {@link ClientEntity} list, removing any duplicates.
 *
 * @param sources
 *
 * @see {@link primaryAddressesFromClientEntity}
 * @see {@link clientAddressEquals}
 */
export const collectPrimaryAddresses = (
  sources: ClientEntity[]
): PrimaryClientAddress[] =>
  sources
    .flatMap(primaryAddressesFromClientEntity)
    .reduce(uniquePrimaryAddresses, []);
